import styled from "styled-components";
import { V3TextInput } from "../TextInput/V3TextInput";

export const ShareLinkRowItemWrapper = styled.div`
    display: flex;
    align-items: center;
   
    > div {
        margin-right: 8px;
        margin-bottom: 12px;

        &:nth-child(1) {
            flex-grow: 1;
        }
    }
`;

export const ShareLinkRowInput = styled(V3TextInput)`
    cursor: pointer;

    &:focus {
        outline: none;
        border: 1px solid transparent;
    }
`;